var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page--invoice-edit"},[_c('h1',[_vm._v(_vm._s(_vm.$t('invoice.action.edit')))]),(_vm.invoice)?_c('app-invoice-form',{attrs:{"invoice":_vm.invoice,"saving":_vm.saving},on:{"save":_vm.onSave}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }